import React from "react";
import { HiOutlineSearch, HiX } from "react-icons/hi";
import { classNames } from "Utils/utils";

const PaFilterBar = ({
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search…",
  filters = null,
  onClear,
  resultCount = null,
  className,
}) => {
  const showClear =
    typeof onClear === "function" &&
    (searchValue || (filters && React.Children.count(filters) > 0));

  return (
    <div
      className={classNames(
        "flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between",
        className
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-center">
        {typeof onSearchChange === "function" ? (
          <div className="relative w-full sm:max-w-xs">
            <HiOutlineSearch
              className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
              aria-hidden="true"
            />
            <input
              type="search"
              value={searchValue}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={searchPlaceholder}
              className="block w-full rounded-lg border border-gray-300 py-2 pl-9 pr-3 text-sm text-gray-900 placeholder:text-gray-400 focus-visible:border-indigo-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
            />
          </div>
        ) : null}
        {filters ? (
          <div className="flex flex-wrap items-center gap-2">{filters}</div>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {typeof resultCount === "number" ? (
          <span className="text-sm text-gray-500">
            {resultCount} {resultCount === 1 ? "result" : "results"}
          </span>
        ) : null}
        {showClear ? (
          <button
            type="button"
            onClick={onClear}
            className="inline-flex items-center gap-1 rounded-lg px-2 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
          >
            <HiX className="h-4 w-4" aria-hidden="true" />
            Clear filters
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default PaFilterBar;
